export const MyrAPIEndpoints = {
    ADDRESS: 'member/address',
    CARD: 'member/card',
    SUMMARY: 'member/summary',
    PROFILE: 'member/profile',
    SERVICE: 'member/service',
    POINTS: 'member/points',
    EMAIL: 'member/email',
    PASSWORD: 'member/password',
    USERNAME: 'member/username',
    OTP_SEND: 'otp/send',
    EKYC: 'member/ekyc',
    EMAIL_UPDATE: 'email/update', //verify new email
    EMAIL_VERIFY: 'email/verify', //verify existing email
    SERVICE_DELETE: 'member/service/delete',
    LOGOUT_ALL: 'member/logout-all',
    SOCIAL_DELETE: 'member/social/provider',
};
